import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<React.StrictMode><App /></React.StrictMode>)

// Ativa o Service Worker — necessário para PWA offline e publicação nas lojas
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Quando há nova versão: manda o SW em espera assumir o controle,
    // depois recarrega a página para carregar os novos arquivos JS/CSS.
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      // controllerchange dispara quando o novo SW assume — aí recarrega
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload()
      }, { once: true })
    }
  }
})
